<div class="db-optimization-success">
  <div>
    <img [src]="'assets/images/icons/lightning.svg'" class="optimization-progress__lightning"/>
    <p *ngIf="!!websiteUrl" class="website-title mb14">
      <i class="db-icon db-icon-ds-link"></i>
      <span>{{websiteUrl}}</span>
    </p>
    <h3 class="db-optimization-success__title">
      10Web has successfully<br/> optimized your {{userSubscription?.trialBoosterClient ? 'homepage' : 'website'}}
    </h3>
    <p class="db-optimization-success__subtitle mt4">Please check your new PageSpeed score from your<br/> dashboard to see how it compares with the old score.</p>
    <ng-container *ngIf="userSubscription?.trialBoosterClient && !cannotClearCache">
      <div class="db-incognito-mode mt30">
        <div>
          <!--<i class="db-icon db-icon-ds-icon-incognito"></i>-->
          <img class="db-incognito-img" src="assets/images/icons/incognito.svg" alt="">
          <span>
            <p>Please check your website in incognito mode</p>
            <p>
              <span>In case of any inconsistency change the optimization level and check again.</span>
            </p>
          </span>
        </div>
      </div>
    </ng-container>

    <div class="db-optimization-success__buttons-wrap mt30">
      <button class="ds-btn-green ds-btn-l" (click)="redirect(paidClient)" >
        <span>Check My Score</span>
      </button>
    </div>
  </div>
</div>
